import {
  IcxRefreshAccessTokenDocument,
  IcxRefreshAccessTokenMutation
} from '@generated/graphql';

import { CapaErrorCode } from '@generated/graphql';
import {
  clearStorageAll,
  setStorageItem,
  STORAGE_ACTION
} from '@utils/storage';
import apolloClient from '.';

import AppConfig from '@config/index';

export const GRAPHQL_URL = AppConfig.graphqlUrl;
export const ENV_MODE = AppConfig.mode as
  | 'devleopment'
  | 'production'
  | 'staging'
  | 'pre'
  | undefined;

export const tokenRefresh = async () => {
  const refreshToken = localStorage.getItem(STORAGE_ACTION.REFRESH_TOKEN);

  if (!refreshToken) return null;

  try {
    const { data } = await apolloClient.mutate<IcxRefreshAccessTokenMutation>({
      mutation: IcxRefreshAccessTokenDocument,
      variables: {
        input: {
          refreshToken: refreshToken
        }
      }
    });

    if (data?.icxRefreshAccessToken.result !== CapaErrorCode.Success) {
      clearStorageAll();
      window.location.reload();
      return null;
    }

    const newAccessToken = data.icxRefreshAccessToken.data?.accessToken;
    const newRefreshToken = data.icxRefreshAccessToken.data?.refreshToken;

    if (
      data &&
      data.icxRefreshAccessToken &&
      data.icxRefreshAccessToken.data &&
      data.icxRefreshAccessToken.result === CapaErrorCode.Success
    ) {
      if (refreshToken !== data.icxRefreshAccessToken.data.refreshToken) {
        setStorageItem(STORAGE_ACTION.ACCESS_TOKEN, newAccessToken);
        setStorageItem(STORAGE_ACTION.REFRESH_TOKEN, newRefreshToken);
      }
    }

    return newAccessToken;
  } catch {
    clearStorageAll();
    window.location.reload();
    return null;
  }
};
